import Avatar from '@/components/avatar'
import Username from '@/components/username'
import { cn } from '@/util/cn'
import { IUser } from '@giphy/js-types'

const Attribution = ({
    user,
    className,
    avatarSize = 50,
}: {
    user: IUser
    className?: string
    avatarSize?: number
}) => {
    return (
        <div className={cn('flex gap-2.5 group', className)}>
            <Avatar user={user} size={avatarSize} />
            <div className="flex flex-col font-semibold justify-center">
                <div>{user.display_name}</div>
                <Username noLink user={user} className="group-hover:underline" />
            </div>
        </div>
    )
}

export default Attribution
